import { useEffect, useState } from "react";

type ListenerParams = { x: number; y: number };
type Listener = (coords: ListenerParams) => void;

class ViewportDimensionsManager {
  listeners: Listener[] = [];

  constructor() {
    window.addEventListener("resize", this.updateSubscriptions);
  }

  updateSubscriptions = (e: UIEvent) => {
    this.listeners.forEach((listener) =>
      listener({
        x: window.innerWidth,
        y: window.innerHeight,
      })
    );
  };

  subscribe = (listener: Listener) => {
    this.listeners.push(listener);

    const unsubscribe = () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };

    return unsubscribe;
  };
}

const manager = new ViewportDimensionsManager();

const useViewportDimensions = () => {
  const [{ x, y }, setDimensions] = useState({
    x: window.innerWidth,
    y: window.innerHeight,
  });

  useEffect(() => {
    const unsubscribe = manager.subscribe(setDimensions);
    return unsubscribe;
  }, []);

  return { x, y };
};

export default useViewportDimensions;
